export const PLAYERS_KEY = 'players';
export const TEAMS_KEY = 'teams';
export const TAGS_KEY = 'tags';

export const SUGGESTION_LABELS = {
    [PLAYERS_KEY]: 'PLAYERS',
    [TEAMS_KEY]: 'TEAMS',
    [TAGS_KEY]: 'TAGS',
};

export const SUGGESTION_TYPES = {
    [PLAYERS_KEY]: 'p',
    [TEAMS_KEY]: 't',
    [TAGS_KEY]: 'g',
};

export const SUGGESTION_FIELD_IDS = {
    [PLAYERS_KEY]: '165',
    [TEAMS_KEY]: '164',
    [TAGS_KEY]: '169',
};
